import { ChecklistInterface } from '../interfaces/checklist';

export class Checklist implements ChecklistInterface {
    id_checklist?: number;
    name: string;
    description: string;

    constructor() {
        this.name = '';
        this.description = '';
    }
}